<template>
  <div class="col-xs-12">


        <spinner size="large" v-if="flagMovingAverageDataIsLoading"></spinner>
        <div v-else class="col-xs-12">
                
            <div class="input-daterange form-group row">
                <div class="input-date-time-picker" >

                    <div class="col-sm-12 col-md-6">
                        <div class="col-sm-12 col-md-12" align="left">
                            <div class="col-md-6 col-sm-12">
                                <label for="startDateTime">{{ labelStartDate[actualLanguage] }}</label>
                                <date-picker
                                    class="el-input__inner form-control"
                                    v-model="myStartDate"
                                    type="date"
                                    placeholder=""
                                    clear-icon=""
                                    format="yyyy-MM-dd"
                                    value-format="timestamp"
                                />
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <label for="startDateTime">{{ labelStartTime[actualLanguage] }}</label>
                                <time-select
                                    v-model="startTime"
                                    placeholder=""
                                    clear-icon=""
                                    :picker-options="{
                                        start: '00:00',
                                        step: '01:00',
                                        end: '24:00'
                                    }"
                                />
                            </div>
                        </div>

                        <div class="col-md-12 col-sm-12" align="left">
                            <div class="col-md-6 col-sm-12">
                                <label for="startDateTime">{{ labelEndDate[actualLanguage] }}</label>
                                <date-picker
                                    class="el-input__inner form-control"
                                    v-model="myEndDate"
                                    type="date"
                                    placeholder=""
                                    clear-icon=""
                                    format="yyyy-MM-dd"
                                    value-format="timestamp"
                                />
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <label for="startDateTime">{{ labelEndTime[actualLanguage] }}</label>
                                <time-select
                                    v-model="endTime"
                                    placeholder=""
                                    clear-icon=""
                                    :picker-options="{
                                        start: '00:00',
                                        step: '01:00',
                                        end: '24:00'
                                    }"
                                />
                            </div>
                        </div>
                    </div>


                    <div class="col-md-6 col-xs-12" align="center">
                        <div class="col-xs-12 push">
                        <div class="form-group">
                            <label class="col-xs-12">{{labelDataSamplingTitle[actualLanguage]}}</label>
                            <div class="col-xs-12">
                                <label class="radio-inline" for="example-inline-radio1">
                                    <input type="radio" value="Automatic" v-model="dataSamplingSelect"> {{labelDataSamplingAuto[actualLanguage]}}
                                </label>
                                <label class="radio-inline" for="example-inline-radio3">
                                    <input type="radio" value="Hour" v-model="dataSamplingSelect"> {{labelDataSamplingHour[actualLanguage]}}
                                </label>
                                <label class="radio-inline" for="example-inline-radio3">
                                    <input type="radio" value="Day" v-model="dataSamplingSelect"> {{labelDataSamplingDays[actualLanguage]}}
                                </label>
                            </div>
                        </div>
                        </div>


                      <div class="col-xs-12">
                        <button type="button" @click="refreshGraph()" class="btn btn-success" name="button"><spinner size="small" v-if="flagGraphDataIsLoading"></spinner>
                        <span v-else><i class="fa fa-repeat pull-left"></i>{{ labelButtonRefresh[actualLanguage] }}</span></button>
                      </div>
                  </div>


                </div>
            </div>






            <spinner size="small" v-if="flagMovingAverageDataIsLoading"></spinner>
            <div v-else class="row">
                <div v-if="flagDisplayGraph"  class="col-sm-12 col-md-9">
                    <h4 class="font-w300 push-10 align-center">{{ graphTitle[actualLanguage] }}</h4>

                    <div id="chart">
                    <apexchart type="area" height="400" :options="chartOptions" :series="chartDataSeries"></apexchart>
                    </div>
                </div>



                <div class="col-sm-12 col-md-3 align-center">

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success" >
                            <input @change="updateChartData" type="checkbox" checked v-model="display001H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 1 hr
                        </label>
                    </div>


                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success">
                            <input @change="updateChartData" type="checkbox" checked v-model="display004H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 4 hr
                        </label>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success">
                            <input @change="updateChartData" type="checkbox" checked v-model="display006H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 6 hr
                        </label>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success">
                            <input @change="updateChartData" type="checkbox" checked v-model="display012H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 12 hr
                        </label>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success">
                            <input @change="updateChartData" type="checkbox" checked v-model="display024H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 1 {{buttonLabelMA_Days[actualLanguage]}}
                        </label>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success">
                            <input @change="updateChartData" type="checkbox" checked v-model="display072H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 3 {{buttonLabelMA_Days[actualLanguage]}}
                        </label>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success">
                            <input @change="updateChartData" type="checkbox" checked v-model="display168H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 7 {{buttonLabelMA_Days[actualLanguage]}}
                        </label>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success">
                            <input @change="updateChartData" type="checkbox" checked v-model="display336H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 14 {{buttonLabelMA_Days[actualLanguage]}}
                        </label>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H" align="left" class="col-sm-3 col-md-12">
                        <label class="css-input css-checkbox css-checkbox-success">
                            <input @change="updateChartData" type="checkbox" checked v-model="display720H">
                            <span></span> {{ buttonLabelMA[actualLanguage] }} 30 {{buttonLabelMA_Days[actualLanguage]}}
                        </label>
                    </div>

                </div>
            </div>


            <div v-if="flagMovingAverageDataAvailable" class="col-xs-12 col-sm-12 align-center">
                <download-csv class = "btn btn-default" :data = "histogramDataDownloadDay" name = "ChannelHistogramDayData.csv"><i class="fa fa-download fa-1x push-5-r "></i>{{labelButtonDownloadData[actualLanguage]}}</download-csv>
            </div>
        </div>
  </div>

</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters, mapActions} from 'vuex'
import Spinner from '../../../components/Spinner.vue'
import LineChart from '@/components/LineChart'

import Vue from 'vue'
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)


import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';


//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
//Next line are executed in PortGraph!!!
//Vue.use(VueApexCharts)
//Vue.component('apexchart', VueApexCharts)

export default {
  props: ['channel_id'],
  data() {
    return {
        timeRange : 0,
        actualLanguage : "FR",
        flagMovingAverageDataAvailable:false,
        flagMovingAverageDataIsLoading:true,
        flagDisplayGraph:false,
        flagGraphDataIsLoading : false,
        movingAverageData:[],
        crunchedData:{},


        myStartDate: '',
        myEndDate: '',
        startTime: '00:00',
        endTime: '00:00',
        myStartDateTime : this.startDate,
        myEndDateTime : this.endDate,
        dataSamplingSelect : 'Automatic',

        display5Min : false,
        display001H : false,
        display004H : false,
        display006H : false,
        display012H : false,
        display024H : false,
        display072H : false,
        display168H : false,
        display336H : false,
        display720H : false,

        graphTitle: {FR: "Puissance moyenne (Watts)", EN: 'Average power (Watts)'},
        buttonLabelMA: {FR: "Moyenne", EN: 'Average'},
        buttonLabelMA_Days: {FR: "jours", EN: 'days'},
        graphLabelLastReading: {FR: "Dernière mesure", EN: 'Last reading'},

        labelStartDate: {FR: 'Date de début', EN: 'Start date'},
        labelStartTime: {FR: 'Heure de début', EN: 'Start time'},

        labelEndDate: {FR: 'Date de fin', EN: 'End date'},
        labelEndTime: {FR: 'Heure de fin', EN: 'End time'},

        labelButtonRefresh: {FR: 'Rafraichir', EN: 'Refresh'},

        labelDataSamplingTitle: {FR: 'Type de données :', EN: 'Data type :'},
        labelDataSamplingAuto: {FR: 'Automatique', EN: 'Automatic'},
        labelDataSamplingHour: {FR: 'Heure', EN: 'Hour'},
        labelDataSamplingDays: {FR: 'Jour', EN: 'Days'},

      //--------------------------------------------------------
      //New Graph variables
      //--------------------------------------------------------
      chartDataSeries: [{
        name: 'TBD',
        data: [[1324508400000, 34], [1324594800000, 54],[1326236400000, 43],[1326236405000, 43],[1326236406000, 53],[1326236406500, 63]],
      }],
        
      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 400,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
        },
        tooltip:{
            x :{format : 'dd MMM hh:mm'}
          },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          },
        },
        xaxis: {
            type: 'datetime'
          }
      },


    }
  },

  components: {
    LineChart,
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect,
  },

  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },

  methods: {

    refreshGraph(){
        this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
        this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)
        this.getMovingAverageLogData()
        
        },

   getMovingAverageLogData(){
        this.flagGraphDataIsLoading = true
        var requestData = { 'postAction':'GetMovingAverageLog',
                            'bundleId':this.actualBundle.bundle_id,
                            'channelId':this.channel_id,
                            'start':this.myStartDateTime,
                            'end':this.myEndDateTime,
                            'dataSampling':this.dataSamplingSelect,
                            }

        this.$store.dispatch('sessionStore/postChannel', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                this.movingAverageData = response.data.LogItems
                this.updateChartData()
                this.flagGraphDataIsLoading = false
                this.flagMovingAverageDataIsLoading = false
                }
                else{ 
                    window.alert(response.PromptMessage[this.actualLanguage])
                    this.flagGraphDataIsLoading = false
                    }
            }) 
      },


    updateChartData(){

        this.chartDataSeries = []
        var NewGraphDataTempo = []

        this.flagDisplayGraph = false

        if(this.display001H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_001H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"1 hr", data:NewGraphDataTempo})
        }

        if(this.display004H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_004H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"4 hr", data:NewGraphDataTempo})
        }

        if(this.display006H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_006H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"6 hr", data:NewGraphDataTempo})
        }

        if(this.display012H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_012H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"12 hr", data:NewGraphDataTempo})           
        }

        if(this.display024H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_024H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"24 hr", data:NewGraphDataTempo})
        }

        if(this.display072H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_072H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"3 jr/days", data:NewGraphDataTempo})
        }

        if(this.display168H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_168H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"7 jr/days", data:NewGraphDataTempo})
        }

        if(this.display336H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_336H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"14 jr/days", data:NewGraphDataTempo})
        }

        if(this.display720H){
            NewGraphDataTempo = []
            for(var i = 0; i < this.movingAverageData.length;i++){
                NewGraphDataTempo.push([this.movingAverageData[i].timestamp,this.movingAverageData[i].MA_720H.toFixed(3)])
            }
            this.chartDataSeries.push({name:"30 jr/days", data:NewGraphDataTempo})
        }



        this.$nextTick(() => {
          this.flagDisplayGraph = true
        });
      
    },

    formatTimeToUnix(date, time) {
        const unixTime = moment(date)
        .set('hour', time.split(':')[0])
        .set('minute', time.split(':')[1])
        .set('seconds', 0)
        .unix()

        return unixTime
    },

  },
  mounted() {

    this.timeRange = this.endDate - this.startDate


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.display5Min = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual
    this.display001H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H
    this.display004H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H
    this.display006H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H
    this.display012H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H
    this.display024H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H
    this.display072H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H
    this.display168H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H
    this.display336H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H
    this.display720H = this.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H

    this.myStartDate = new Date(this.startDate * 1000),
    this.myEndDate = new Date(this.endDate * 1000)


    var DateStringSplit = this.myStartDate.toString().split(':')
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]

    DateStringSplit = this.myEndDate.toString().split(':')
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]
    
    
    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)


    this.getMovingAverageLogData()


  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// MovingAverageGraph.vue?c6a2a236